export default class Storefront {
  constructor() {
    if (Storefront._instance) Storefront._instance;
    Storefront._instance = this;

    const technicalDataEl = document.querySelector('[data-technical]');
    if (!technicalDataEl)
      console.error(
        'utils/storefront/index.js: Could not locate Storefront credentials',
      );

    this.data = JSON.parse(technicalDataEl.textContent);
    this.apiVersion = this.data.apiVersion;
    this.shopName = this.data.shopName;
    this.storefrontToken = this.data.storefrontToken;

    this.headers = {
      'X-Shopify-Storefront-Access-Token': this.storefrontToken,
      'Content-Type': 'application/json',
    };
  }

  async request({ query, variables = {} }) {
    const response = await fetch(
      `https://${this.shopName}/api/${this.apiVersion}/graphql.json`,
      {
        headers: this.headers,
        method: 'POST',
        body: JSON.stringify({ query, variables }),
      },
    );

    return await response.json();
  }
}
